const config =
  process.env.NODE_ENV === "production"
    ? require("./configureStore.prod")
    : require("./configureStore.dev");
// export const history = config.history;
export default config.default;
